import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/houseRules/useHouseRulesQueryKeys.ts
var t = e("houseRules", { list: () => ["list"] });
//#endregion
export { t as houseRulesQueryKeys };
